import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import RoutesPath from "../../../utils/Paths";

/**
 * HeroLandingSection
 * Rendered right after <Header />, before <Categories />.
 * Mirrors the "Find the right talent, right on the map" hero screenshot.
 */
const HeroLandingSection = () => {
  const navigate = useNavigate();

  const scrollToMap = () => {
    const el = document.getElementById("home-map-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <HeroStyled>
      <div className="container py-5 text-center">

        {/* Headline */}
        <h1 className="headline mb-4">
          Find Jobs, Services, Freelancers, and <br />Skilled Professionals - Nearby or <br />Worldwide on the Map.{" "}
          {/* <span className="accent">Nearby</span>
          <br />
          <span className="accent">or Anywhere in the World.</span> */}
        </h1>

        {/* Sub-headline */}
        {/* <p className="subtitle mx-auto mb-4" style={{ color: '#0fd3bb',fontSize: '18px' }}>
          GigFalcon puts every project, job, freelancer and local service provider on one interactive map—so clients/customers and employers can quickly discover and hire the right people nearby or anywhere in the world.
        </p> */}

        {/* Search bar */}
        {/* <div className="search-bar mx-auto mb-4 d-flex flex-column flex-md-row align-items-stretch">
          <div className="search-service d-flex align-items-center flex-grow-1">
            <span className="service-chevron">&#8250;</span>
            <input
              type="text"
              className="service-input"
              placeholder="What service do you need?"
            />
          </div>
          <div className="search-divider d-none d-md-block" />
          <input
            type="text"
            className="location-input flex-grow-1"
            placeholder="Location (or anywhere)"
          />
          <button className="search-btn" onClick={scrollToMap}>
            Search
          </button>
        </div> */}

        {/* CTA buttons */}
        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
          <button className="btn-map" onClick={scrollToMap}>
            Browse the Map
          </button>
        </div>

        {/* Feature bullets */}
        {/* <div className="features d-flex flex-wrap justify-content-center gap-3 gap-md-4">
          <span>&#8226;&nbsp;Every Skill on the Map</span>
          <span>&#8226;&nbsp;Local &amp; Global Talent</span>
          <span>&#8226;&nbsp;Free to Browse</span>
        </div> */}
      </div>
    </HeroStyled>
  );
};

export default HeroLandingSection;

/* ── Styles ─────────────────────────────────────────────────────────────── */
const TEAL = "#0fd3bb";
const DARK = "#222222";
const GREY = "#666666";

const HeroStyled = styled.section`
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;

  .kicker {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2.5px;
    color: ${TEAL};
    text-transform: uppercase;
    margin-bottom: 0;
  }

  .headline {
    font-size: 32px;
    font-weight: 800;
    line-height: 1.1;
    color: ${DARK};
    font-family: "MS_Bold", "Arial Black", sans-serif;
  }

  .accent {
    color: ${TEAL};
  }

  .subtitle {
    font-size: 1rem;
    max-width: 900px;
    line-height: 1.6;
  }

  /* ── Search bar ── */
  .search-bar {
    max-width: 660px;
    border: 1.5px solid #e0e0e0;
    border-radius: 50px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);

    @media (max-width: 767px) {
      border-radius: 14px;
    }
  }

  .search-service {
    padding: 0 16px;
    border-right: 1px solid #e0e0e0;
    min-width: 0;

    @media (max-width: 767px) {
      border-right: none;
      border-bottom: 1px solid #e0e0e0;
      padding: 10px 16px;
    }
  }

  .service-chevron {
    color: ${GREY};
    font-size: 22px;
    line-height: 1;
    margin-right: 6px;
    user-select: none;
  }

  .service-input,
  .location-input {
    border: none;
    outline: none;
    font-size: 14px;
    color: ${DARK};
    background: transparent;
    padding: 14px 12px;
    width: 100%;

    &::placeholder {
      color: #aaa;
    }
  }

  .location-input {
    @media (max-width: 767px) {
      border-bottom: 1px solid #e0e0e0;
    }
  }

  .search-divider {
    width: 1px;
    background: #e0e0e0;
    margin: 10px 0;
  }

  .search-btn {
    background-color: ${TEAL};
    color: #ffffff;
    border: none;
    padding: 14px 26px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    border-radius: 0 50px 50px 0;
    white-space: nowrap;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #0bbea9;
    }

    @media (max-width: 767px) {
      border-radius: 0 0 14px 14px;
      width: 100%;
    }
  }

  /* ── CTA buttons ── */
  .btn-map {
    background-color: ${TEAL} !important;
    color: #ffffff;
    border: none;
    padding: 12px 28px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #0bbea9;
    }
  }

  .btn-post {
    background-color: #ffffff;
    color: ${DARK};
    border: 1.5px solid #cccccc;
    padding: 12px 28px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    &:hover {
      border-color: ${TEAL};
      color: ${TEAL};
    }
  }

  /* ── Feature bullets ── */
  .features span {
    font-size: 13px;
    color: ${GREY};
  }
`;
